export const COMMON_CFN_READ_ONLY_ROLE_NAME = 'AwsGsaasReadOnlyRole';

export const COMMON_CFN_READ_WRITE_ROLE_NAME = 'AwsGsaasReadWriteRole';
export const DATA_ANALYTICS_READ_ONLY_ROLE_NAME = 'AwsGsaasDataAnalyticsReadOnlyRole';

export function getRoleArn(accountId: string, roleName: string): string {
  return `arn:aws:iam::${accountId}:role/${roleName}`;
}
